export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsNo') || '订单产品编号',
    field: 'orderGoodsNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.goods_label_identifyGoodsNo') || '识别编号',
    field: 'identifyGoodsNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsName') || '订单产品名称',
    field: 'orderGoodsDisplayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.goods_label_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
